// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeedbackRequest
 */
export interface FeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof FeedbackRequest
     */
    interactionId: string;
    /**
     * 
     * @type {FeedbackRequestRatingEnum}
     * @memberof FeedbackRequest
     */
    rating: FeedbackRequestRatingEnum;
    /**
     * 
     * @type {string}
     * @memberof FeedbackRequest
     */
    reason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeedbackRequest
     */
    cause?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeedbackRequest
     */
    comment?: string | null;
}


/**
 * @export
 */
export const FeedbackRequestRatingEnum = {
    Positive: 'positive',
    Negative: 'negative'
} as const;
export type FeedbackRequestRatingEnum = typeof FeedbackRequestRatingEnum[keyof typeof FeedbackRequestRatingEnum];


/**
 * Check if a given object implements the FeedbackRequest interface.
 */
export function instanceOfFeedbackRequest(value: object): value is FeedbackRequest {
    if (!('interactionId' in value) || value['interactionId'] === undefined) return false;
    if (!('rating' in value) || value['rating'] === undefined) return false;
    return true;
}

export function FeedbackRequestFromJSON(json: any): FeedbackRequest {
    return FeedbackRequestFromJSONTyped(json, false);
}

export function FeedbackRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeedbackRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'interactionId': json['interaction_id'],
        'rating': json['rating'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'cause': json['cause'] == null ? undefined : json['cause'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function FeedbackRequestToJSON(json: any): FeedbackRequest {
    return FeedbackRequestToJSONTyped(json, false);
}

export function FeedbackRequestToJSONTyped(value?: FeedbackRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'interaction_id': value['interactionId'],
        'rating': value['rating'],
        'reason': value['reason'],
        'cause': value['cause'],
        'comment': value['comment'],
    };
}

